import React from 'react';
import PropTypes from 'prop-types';

const MenuIcon = ({ icon }) => (icon ? <i className={`fas ${icon} fa-lg`} /> : null);

MenuIcon.propTypes = {
  icon: PropTypes.string
};

MenuIcon.defaultProps = {
  icon: null
};

export default MenuIcon;
